export const SidebarData = [
  {
    title: "Create Customer",
    path: "/admin/dashboard/create-customer",
    roles: ["staff", "admin", "superadmin"],
  },
  {
    title: "Manage Customers",
    path: "/admin/dashboard/manage-customer",
    roles: ["staff", "admin", "superadmin"],
  },
  {
    title: "Manage Purchases",
    path: "/admin/dashboard/manage-purchase",
    roles: ["staff", "admin", "superadmin"],
  },
];

export const CustomerSidebarData = [
  {
    title: "Your Purchases",
    path: "/customer/dashboard/purchases",
  },
  {
    title: "Free Stringing Service",
    path: "/customer/dashboard/services",
  },
  {
    title: "Transactions",
    path: "/customer/dashboard/your-transactions",
  },
  {
    title: "Create Support Ticket",
    path: "/customer/dashboard/create-ticket",
  },
];